import { fromUnixTime, differenceInHours, differenceInMinutes } from 'date-fns';

const getOnlineStatusWording = ({ lastModifiedAtUnix, i18nFn }) => {
  // backend will return null, if offline over 3hr
  if (!lastModifiedAtUnix) return i18nFn('online_state_offline');

  const lastModified = fromUnixTime(lastModifiedAtUnix);
  const hoursDiff = differenceInHours(Date.now(), lastModified);
  const minutesDiff = differenceInMinutes(Date.now(), lastModified);
  if (hoursDiff >= 3) {
    return i18nFn('online_state_offline');
  } else if (hoursDiff >= 1) {
    return i18nFn('offline_state_hours_ago', [hoursDiff]);
  } else if (minutesDiff >= 1) {
    return i18nFn('offline_state_minutes_ago', [minutesDiff]);
  } else {
    return i18nFn('offline_state_minutes_ago', [1]);
  }
};

export { getOnlineStatusWording };
